export default "__VITE_ASSET__70607dab__"